import { UploadedFile } from 'openapi/models/UploadedFile'

import { FileState } from '../stores/app-store'

/**
 * Extracts uploaded files from an array of FileState objects
 * @param fileStates - FileState metadata.
 * @returns Array of successfully uploaded files, filtering out any null values
 */
export const getUploadedFiles = (fileStates: FileState[]) => {
  return fileStates
    .map((file) => file.uploadedFile)
    .filter((file): file is UploadedFile => file !== null)
}
